<script lang="ts">
	import type { Price } from '$lib/components/types';
	import Link from '$lib/components/atoms/link/Link.svelte';
	import CardTitle from '$lib/components/recommendation/getyourguide/GetYourGuideCardTitle/GetYourGuideCardTitle.svelte';
	import { formatPrice } from '$lib/utils/formatPrice';
	import * as m from '$paraglide/messages';
	import { languageTag } from '$paraglide/runtime';
	import { createEventDispatcher } from 'svelte';
	import RecommendationCardTemplate from '../RecommendationCardTemplate.svelte';

	export let bookUrl: string = '';
	export let imageUrl: string | undefined = undefined;
	export let isHovered: boolean = false;
	export let name: string = '';
	export let price: Price | undefined = undefined;
	export let isLoading: boolean = false;
	export let reviewText: string | undefined = undefined;

	let extraClasses = '';
	export { extraClasses as class };

	const icon = 'gyg';
	const scheme = 'tourism';

	const dispatch = createEventDispatcher<{
		bookClick: void;
	}>();
</script>

<RecommendationCardTemplate
	{icon}
	{isHovered}
	{imageUrl}
	{isLoading}
	isSquare
	on:cardClick
	class={extraClasses}
>
	<svelte:fragment slot="title">
		<CardTitle {name} {scheme} titleOnTwoLines />
	</svelte:fragment>
	<svelte:fragment slot="rate">
		{#if reviewText}
			<span class="truncate">{reviewText}</span>
		{/if}
	</svelte:fragment>
	<svelte:fragment slot="buttons">
		<Link
			button="filled"
			color="light"
			size="sm"
			href={bookUrl}
			target="_blank"
			rel="external"
			class="w-full"
			icon="open-in-new"
			label={price
				&& m.poi_card__book_min_price({
					price: formatPrice({
						amount: price.amount,
						currency: price.currency,
						language: languageTag(),
					}),
				})}
			onclick={() => dispatch('bookClick')}
		/>
	</svelte:fragment>
</RecommendationCardTemplate>
